export const isPhone = (text: string) => /^\+?\d/.test(text)
export const isEmail = (text: string) => text.includes('@')
export const isNonClickable = (subject: string) => isPhone(subject) || isEmail(subject)
